import { render } from "./ggjxgrycgbdDetail.vue?vue&type=template&id=f61682c6&scoped=true&ts=true"
import script from "./ggjxgrycgbdDetail.vue?vue&type=script&lang=ts"
export * from "./ggjxgrycgbdDetail.vue?vue&type=script&lang=ts"

import "./ggjxgrycgbdDetail.vue?vue&type=style&index=0&id=f61682c6&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f61682c6"]])

export default __exports__